import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { formatDate } from '../../helpers/dateHelpers'

function sortByDate(a: any, b: any) {
  const dateA: any = new Date(a.updated_at)
  const dateB: any = new Date(b.updated_at)
  return dateB - dateA
}

const statusOrder = ['new', 'open', 'pending', 'solved', 'closed']
function sortByStatus(a: any, b: any) {
  return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status)
}

const useStyles = makeStyles(() =>
  createStyles({
    row: {
      cursor: 'pointer',
    },
  })
)

export function ZendeskTickets({ tickets }: any) {
  const styles = useStyles()
  if (!tickets || tickets.length === 0) {
    return <Typography variant="body1">No tickets found.</Typography>
  }

  const sortedTickets = tickets.sort(sortByDate).sort(sortByStatus)

  const openTicket = (id: string) => {
    window.open(`https://cloudtrucks.zendesk.com/agent/tickets/${id}`, '_blank')?.blur()
    window.focus()
  }

  const clickOpenTicket = (id: string) => () => {
    openTicket(id)
  }

  const middleMouseOpenTicket = (id: string) => (e: any) => {
    if (e.button === 1) {
      openTicket(id)
    }
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Last updated</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedTickets.map((ticket: any) => (
            <TableRow
              key={ticket.id}
              hover
              className={styles.row}
              onClick={clickOpenTicket(ticket.id)}
              onMouseDown={middleMouseOpenTicket(ticket.id)}
            >
              <TableCell component="th" scope="row">
                {ticket.id}
              </TableCell>
              <TableCell>{formatDate(ticket.updated_at)}</TableCell>
              <TableCell>{ticket.raw_subject}</TableCell>
              <TableCell>{ticket.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
